module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div\r\n    class="livechat_prechat_plain_text_wrapper prechat_bubble livechat_message_bubble_wrapper ' +
((__t = ( hidden ? 'livechat_hidden' : '' )) == null ? '' : __t) +
'">\r\n    <div class="livechat_message_bubble livechat_question_text">\r\n        <div class="livechat_prechat_plain_text_greet"></div>\r\n        <div class="livechat_prechat_plain_text ">\r\n            <span class="apexchat_text">\r\n                ' +
((__t = (text)) == null ? '' : __t) +
'\r\n            </span>\r\n        </div>\r\n    </div>\r\n</div>';

}
return __p
}